import { jsx } from 'react/jsx-runtime';
import pricingContextModuleHelper from '@vp/pricing-context-module/helpers.js';
import { useState, useEffect } from 'react';
import { PricingReactContext } from './context.mjs';
import { getPricingContext, getPricingContextModule } from './module.mjs';

function PricingContextProvider(props) {
    const [currentContext, setCurrentContext] = useState(undefined);
    const [readyToInitialize, setReadyToInitialize] = useState(false);
    const merchantId = props.initializationConfig?.merchantId || "";
    const market = props.initializationConfig?.market || "";
    const isDevelopmentMode = props.initializationConfig?.isDevelopmentMode || false;
    useEffect(() => {
        if (readyToInitialize && merchantId !== "" && market !== "") {
            if (isDevelopmentMode) {
                console.log("Going to initialize the pricing context");
            }
            pricingContextModuleHelper.initializePricingContext({
                merchantId: merchantId,
                market: market,
                isDevelopmentMode: isDevelopmentMode,
            });
        }
    }, [readyToInitialize, merchantId, market, isDevelopmentMode]);
    useEffect(() => {
        const moduleInitializedEventName = "PCXT-V3-ModuleInitialized";
        const contextChangedEventName = "PCXT-V3-ContextChanged";
        function handleModuleInitializedEvent() {
            if (isDevelopmentMode) {
                console.log("Pricing context module has been initialized.");
            }
            const context = getPricingContext();
            if (context) {
                setCurrentContext(context);
            }
        }
        function handleContextChangedEvent() {
            if (isDevelopmentMode) {
                console.log("Pricing context has changed.");
            }
            const context = getPricingContext();
            if (context) {
                setCurrentContext(context);
            }
        }
        document.addEventListener(moduleInitializedEventName, handleModuleInitializedEvent);
        document.addEventListener(contextChangedEventName, handleContextChangedEvent);
        setReadyToInitialize(true);
        setCurrentContext(getPricingContext());
        return () => {
            document.removeEventListener(moduleInitializedEventName, handleModuleInitializedEvent);
            document.removeEventListener(contextChangedEventName, handleContextChangedEvent);
        };
    }, [isDevelopmentMode]);
    return (jsx(PricingReactContext.Provider, { value: { context: buildReactPricingContext(currentContext) }, children: props.children }));
}
function buildReactPricingContext(context) {
    const module = getPricingContextModule();
    if (!module || !context) {
        return undefined;
    }
    return {
        ...context,
        getEncodedContextString: () => module.getEncodedContextString(),
        setCouponCode: (coupon) => module.setCouponCode(coupon),
        setEffectiveDateTime: (dateTime) => module.setEffectiveDateTime(dateTime),
        setVatInclusive: (isInclusive) => module.setVatInclusive(isInclusive),
    };
}

export { PricingContextProvider };
//# sourceMappingURL=provider.mjs.map
